export default __webpack_public_path__ + "static/media/enhanced-popup-banner.c4ba2dcf.jpeg";